import { breakpoint } from '@sketch/global-styles'
import styled, { css } from 'styled-components'
import { ReactComponent as LayersTreeIcon } from '@sketch/icons/img-list-bullet-nested-17'
import { ReactComponent as DividerIcon } from '@sketch/icons/divider-vertical-2'
import { ButtonUnstyled } from '@sketch/components'

/** Only valid for tablets and above */
const PANEL_DEFAULT_WIDTH = 230

export const CanvasLeftPanel = styled.div`
  position: absolute;
  bottom: 59px; /* 51px mobile toolbar + 8px extra space */
  left: 8px;
  z-index: 100;

  /* On mobile we limit the width to not overlap other floating panels */
  max-width: 175px;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  border-radius: ${({ theme }) => theme.radii.large};

  /* 104px = header height (48px) + floating zoom height + bottom margin (34px + 8px) + padding (8px top + 8px bottom) */
  max-height: calc(100vh - 106px);
  display: flex;
  flex-direction: column;

  ${breakpoint('xs')`
     max-width: 230px;
  `}

  ${({ theme }) => breakpoint('sm')`
    top: 8px;
    bottom: auto;
    width: ${PANEL_DEFAULT_WIDTH}px;
    max-width: none;
    box-shadow: 0 4px 8px 0 ${theme.colors.shadow.outer};
    border-radius: ${theme.radii.xlarge};
  `}
`
type CanvasLeftPanelHeaderProps = {
  $isResizing: boolean
}

export const CanvasLeftPanelHeader = styled.div<CanvasLeftPanelHeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* stylelint-disable-next-line scales/space */
  padding: 0 2px;

  ${breakpoint('sm')`
    padding: 0 8px;
  `}

  ${({ $isResizing }) =>
    $isResizing &&
    css`
      pointer-events: none;
    `}
`

export const SelectorContainer = styled.div`
  flex: 1;
  overflow: hidden;
`

export const ToggleLayersTreeContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 8px;
  padding-left: 4px;
`

export const ToggleLayersTreeButtonDivider = styled(DividerIcon)`
  width: 2px;
  height: 32px;
`

type ToggleLayersTreeButtonProps = {
  $isActive: boolean
}

export const ToggleLayersTreeButton = styled(
  ButtonUnstyled
)<ToggleLayersTreeButtonProps>`
  border-radius: ${({ theme }) => theme.radii.large};
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  width: 33px;
  height: 29px;

  ${({ $isActive, theme }) =>
    $isActive
      ? css`
          color: ${theme.colors.sketch.A};
          background-color: ${theme.colors.sketch.F};
        `
      : css`
          &:hover {
            background-color: ${theme.colors.state.hover};
          }
        `}
`

export const ToggleLayersTreeButtonIcon = styled(LayersTreeIcon)`
  width: 17px;
  height: 17px;
  color: currentColor;
`

export const LayersTreeContainer = styled.div<{ $isResizing: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 0;

  ${({ $isResizing }) =>
    $isResizing &&
    css`
      pointer-events: none;
    `}
`
